import { render, staticRenderFns } from "./SuiviMateriel.vue?vue&type=template&id=6bbadd34"
import script from "./SuiviMateriel.vue?vue&type=script&lang=ts"
export * from "./SuiviMateriel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports